import { color as d3Color } from 'd3'

export default function shouldUseWhiteText(rgb: string): boolean {
    const c = d3Color(rgb)
    if (!c) return false

    const { r, g, b } = c.rgb()

    // Relative luminance (WCAG)
    const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255

    return luminance < 0.55
}
